<template>
    <div id="rate-product-wrap">
        <h2>
            Your opinion matters! How would you rate {{ product }}
        </h2>
        <StarRating style="margin-bottom: 1rem;" :initialRating="currentRating" @update:rating="setRating" />
        <label style="margin-top: 1rem;" for="rating-comment">Comment (optional)</label>
        <textarea v-model="comment" id="rating-comment" name="comment" style="width: 100%; resize: none; overflow: auto;" rows="6"></textarea>
        <button :disabled="!isRatingEnabled" class="fa-btn fa-btn-primary fa-btn-modal" @click="submitRating">Submit rating</button>
        <ModalMessage :message="feedbackMessage" :type="messageType" style="margin-top: 1rem; margin-bottom: 1rem;" />
        <NuxtLink v-if="props.productName && !isRatingEnabled" class="fa-btn fa-btn-primary" to="/account">Go to account dashboard</NuxtLink>
    </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue';
import { useUIStore } from '~/store/uiStore';
import APIClient from '~/api/apiClient';
import { CSRFType } from '@/api/apiClient';
import CSRFManager from '~/utils/csrfManager.ts';
import { MessageType, ModalTypes } from '@/types/enums.ts';

const props = defineProps({
  productName: { type: String, default: null }
});


const csrfManager = new CSRFManager(CSRFType.RATE_PRODUCT);
const csrfToken = computed(() => csrfManager.state.csrfToken);
const product = computed(() => props.productName || uiStore.modalMessage);

const feedbackMessage = ref('');
const messageType = ref(MessageType.INFO);

const apiClient = APIClient.getInstance();
const uiStore = useUIStore();
const currentRating = ref(0);
const comment = ref('');
const isRatingEnabled = ref(true);

function setRating(rating) {
    currentRating.value = rating;
}

function submitRating() {
    if(currentRating.value === 0)
    {      
      feedbackMessage.value = 'You haven\'t rated yet. Please click on the stars to set a value between 1 and 5 stars.';
      messageType.value = MessageType.ERROR;
      return;
    }
    rateProduct(product.value, currentRating.value, comment.value);
}

onMounted(async () => {
  await csrfManager.startFetchingToken();
});

onUnmounted(() => {
  csrfManager.stopFetchingToken();
});

function autoCloseModal() {
    uiStore.setPopupMessage("Thank you for rating " + product.value);
    uiStore.setModalType(ModalTypes.INACTIVE);
    
    // Set a timeout for 2 seconds before reloading the page
    setTimeout(() => {
        window.location.reload();
    }, 2000); // 2000 milliseconds = 2 seconds
}

const rateProduct = async (productName, rating) => {
    console.log(`Rating for ${productName}: ${rating} stars`);
    try {
      await csrfManager.fetchToken();
      const response = await apiClient.rateProduct(productName, rating, comment.value, csrfToken.value);
      console.log("Rating response: ", response);
      isRatingEnabled.value = false;
      if (response.valid) {
        messageType.value = MessageType.SUCCESS;
        isRatingEnabled.value = false;
        if(!props.productName)
        {
            feedbackMessage.value = `Thank you for rating ${productName}. This window will close automatically in 10 seconds.`;
            autoCloseModal();
        }
        else
            feedbackMessage.value = `Thank you for rating ${productName}.`;

      } else {
        console.error('Error rating product:', response.message);
        messageType.value = MessageType.ERROR;
        feedbackMessage.value = response.error || 'An unexpected error occurred while rating the product.';
      }
    } catch (error) {
      console.error('Error during rating process:', error);
      feedbackMessage.value = 'An error occurred while processing your rating.';
      messageType.value = MessageType.ERROR;
    }
};

</script>
